const LPT = ({ ...props }) => (
  <svg
    width="640"
    height="680"
    viewBox="0 0 640 680"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M520 400V280H640V400H520Z" fill="url(#paint0_linear_530_4776)" />
    <path d="M260 260V140H380V260H260Z" fill="url(#paint1_linear_530_4776)" />
    <path d="M260 540V420H380V540H260Z" fill="url(#paint2_linear_530_4776)" />
    <path
      d="M5.24537e-06 680L0 560H120V680H5.24537e-06Z"
      fill="url(#paint3_linear_530_4776)"
    />
    <path
      d="M5.24537e-06 400L0 280H120V400H5.24537e-06Z"
      fill="url(#paint4_linear_530_4776)"
    />
    <path
      d="M5.24537e-06 120L0 5.24537e-06L120 0V120H5.24537e-06Z"
      fill="url(#paint5_linear_530_4776)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_530_4776"
        x1="319.651"
        y1="679.989"
        x2="319.654"
        y2="-0.000120569"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A660" />
        <stop offset="1" stop-color="#00EB88" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_530_4776"
        x1="319.651"
        y1="679.989"
        x2="319.654"
        y2="-0.000104968"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A660" />
        <stop offset="1" stop-color="#00EB88" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_530_4776"
        x1="319.651"
        y1="679.989"
        x2="319.654"
        y2="-0.000131989"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A660" />
        <stop offset="1" stop-color="#00EB88" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_530_4776"
        x1="319.651"
        y1="679.989"
        x2="319.654"
        y2="-0.000123143"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A660" />
        <stop offset="1" stop-color="#00EB88" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_530_4776"
        x1="319.651"
        y1="679.989"
        x2="319.654"
        y2="-0.000136654"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A660" />
        <stop offset="1" stop-color="#00EB88" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_530_4776"
        x1="319.651"
        y1="679.989"
        x2="319.654"
        y2="-0.000129899"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A660" />
        <stop offset="1" stop-color="#00EB88" />
      </linearGradient>
    </defs>
  </svg>
);
export default LPT;
